import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CalendarioComponent } from '../calendario/calendario.component';
import { PopoverController } from '@ionic/angular';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import {MessageProvider} from '../../providers/message.provider';
import { MonthPickerComponent } from '../month-picker/month-picker.component';

@Component({
  selector: 'input-calendario',
  templateUrl: './input-calendario.component.html',
  styleUrls: ['./input-calendario.component.scss'],
})
export class InputCalendarioComponent {

  @Input() control: FormControl;
  @Input() isForm = true;
  @Input() placeholder: string;
  @Input() set dataInvalida(value: boolean) {
    // console.log('passou aqui');
    if (value) {
      this.data = undefined;
    }
  }
  @Input() isMonthPick: boolean;
  @Output() validacoes: EventEmitter<any> = new EventEmitter();
  data: any;

  constructor(
    private popoverCtrl: PopoverController,
    private messageProvider: MessageProvider
  ) {}

  async openCalendario(control, ev) {
    const popover = await this.popoverCtrl.create({
      component: this.isMonthPick ? MonthPickerComponent: CalendarioComponent,
      translucent: true,
      mode: 'ios',
      event: ev,
      cssClass: 'popover-calendario',
    });

    await popover.present();
    const responseCalendario = await popover.onWillDismiss();
    if (responseCalendario.data) {
      this.validarData(control, responseCalendario.data);
    }
  }

  async openCalendarioWithoutControl( ev) {
    const popover = await this.popoverCtrl.create({
      component: this.isMonthPick ? MonthPickerComponent: CalendarioComponent,
      translucent: true,
      mode: 'ios',
      event: ev,
      cssClass: 'popover-calendario',
    });

    await popover.present();
    const responseCalendario = await popover.onWillDismiss();
    if (responseCalendario.data) {
      this.validarDataWithoutControl(responseCalendario.data);
    }
  }

  validarData(control, responseCalendario?: any) {
    const params: any = {
      control,
      responseCalendario
    };
    const tipoCalendar = this.isMonthPick ? 'MM/YYYY' : 'DD/MM/YYYY';
    if (responseCalendario && responseCalendario._isAMomentObject) {
      params.tipoEntrada = 'calendario';
      control.setValue(responseCalendario.format(tipoCalendar));
      this.validacoes.emit(params);
    } else if (control.value) {
      const date = moment(control.value, tipoCalendar);
      if (!date.isValid()) {
        control.setValue(undefined);
        this.messageProvider.showToast('Data inválida', 3000);
      } else {
        params.tipoEntrada = 'input';
        this.validacoes.emit(params);
      }
    }
  }

  validarDataWithoutControl(responseCalendario?: any) {
    const params: any = {
      responseCalendario
    };
    if (responseCalendario) {
      this.data = params.responseCalendario.format('DD/MM/YYYY');
      params.tipoEntrada = 'calendario';
      this.validacoes.emit(params);
    } else {
      if (this.data) {
        const date = moment(this.data, 'DD/MM/YYYY');
        if (!date.isValid()) {
          params.value = undefined;
          this.messageProvider.showToast('Data inválida', 3000);
        } else {
          params.value = this.data;
          params.tipoEntrada = 'input';
          this.validacoes.emit(params);
        }
      }
    }
  }

  get calendarMask() {
    return this.isMonthPick ? '00/0000' : '00/00/0000'
  }

  get calendarSize() {
    return this.isMonthPick ? 7 : 10
  }

}
